export const PLATFORMS = {
    shoppa_pos: '__ShoppaPOS__',
    shoppa_backoffice: '__ShoppaBackOffice__'
}
